export default "__VITE_ASSET__f3387112__"